// module-box spacing 默认配置
const defaultSpacing = {
    // 模块白色背景，带有title的模块
    normal: {
        topSpacing: 10,
        btmSpacing: 50,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15
    },
    // 模块为图片或者色块
    colorBlock: {
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
    },
    // 特殊处理md-team(multi-column-info-under-img,multi-column-info-over-img)
    restColorBlock: {
        topSpacing: 10,
        btmSpacing: 40,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15
    },
    restNormal: {
        topSpacing: 10,
        btmSpacing: 30,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15
    },
    brokerListSpacing: {
        topSpacing: 10,
        btmSpacing: 50,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 25
    }
};

export const normal = defaultSpacing.normal;
export const colorBlock = defaultSpacing.colorBlock;
export const restColorBlock = defaultSpacing.restColorBlock;
export const restNormal = defaultSpacing.restNormal;
export const brokerListSpacing = defaultSpacing.brokerListSpacing;
